import axios from 'axios';
import { IGetOneResponse } from '../util/Types/Generic';
import { ApiService } from './ApiService';

export class GroqService extends ApiService {
  static pathName = '/groq';

  static search = (body: {
    prompt: string;
    content?: string;
    instruction?: string;
    persona?: string;
    model: string;
    seed: number;
    temperature: number;
    max_tokens: number;
    top_p: number;
    stop: string | null;
    flowId?: string;
  }): Promise<
    IGetOneResponse<{
      message: string;
    }>
  > => {
    if (body.model === 'llama-4-maverick-17b-128e-instruct') {
      body.model = 'meta-llama/llama-4-maverick-17b-128e-instruct';
    } else if (body.model === 'llama-4-scout-17b-16e-instruct') {
      body.model = 'meta-llama/llama-4-scout-17b-16e-instruct';
    }

    return this.post(`${this.pathName}`, body);
  };

  static whisperLargeV3 = (query: {
    fileUrl: string;
    flowId?: string;
    model: string;
  }): Promise<
    IGetOneResponse<{
      usedTokens: any;
      message: string;
    }>
  > => {
    const handleCorrectModel = (model: string) => {
      switch (model) {
        case 'groq':
          return 'whisper-large-v3';
        case 'groq_v3_turbo':
          return 'whisper-large-v3-turbo';
        default:
          return model;
      }
    };

    const correctModel = handleCorrectModel(query.model);

    return this.post(`${this.pathName}/whisper-large-v3`, {
      fileUrl: query.fileUrl,
      flowId: query.flowId,
      model: correctModel,
    });
  };

  static voices = (): Promise<
    IGetOneResponse<{ voices: { id: string; name: string }[] }>
  > => {
    return ApiService.get(`${this.pathName}/voices`);
  };

  static voiceGenerate = (
    voiceId: string,
    body: any,
  ): Promise<IGetOneResponse<any>> => {
    return ApiService.post(`${this.pathName}/text-to-speech/${voiceId}`, body);
  };

  static voiceGenerateBuffer = (
    voiceId: string,
    body: any,
  ): Promise<IGetOneResponse<any>> => {
    const accessToken = localStorage.getItem('accessToken');

    return axios.post(
      `${import.meta.env.VITE_API_URL}/groq/chatbot/text-to-speech/${voiceId}`,
      body,
      {
        headers: {
          Authorization: `Bearer ${accessToken}`,
        },
        responseType: 'blob',
      },
    );
  };
}
